<template>
  <div>
    <v-data-table id="data-table"
                  :loading="loading"
                  :items="messages"
                  :headers="headers"
                  :server-items-length="serverItemsLength"
                  :items-per-page="perPage"
                  :footer-props="{'items-per-page-options': [10, 25, 50, 100]}"
                  v-resize="adjustTableHeight"
                  :fixed-header="fixedHeader"
                  :height="tableHeight"
                  @update:items-per-page="updateItemsPerPage"
                  @update:page="updatePage">
      <template v-slot:item.created_at="{item: message}">
        <template v-if="message.created_at">
          <a :href="$router.resolve({name: 'admin.mailgun_message.show', params: {messageID: message.id}}).href"
             @click.prevent="openMessageDialog(message.id)">
            {{ message.created_at | datetime('YYYY-MM-DD h:mm a') }}
          </a>

          <v-btn icon
                 class="ml-1"
                 x-small
                 :to="{name: 'admin.mailgun_message.show', params: {messageID: message.id}}"
                 target="_blank">
            <v-icon x-small>
              fas fa-fw fa-external-link-alt
            </v-icon>
          </v-btn>
        </template>
      </template>

      <template v-slot:item.sender="{item: message}">
        <template v-if="message.sender">
          {{ message.sender.email }}
        </template>
        <template v-else>
          {{ message.from_email }}
        </template>
      </template>

      <template v-slot:item.status="{item: message}">
        <MessageStatus :message="message">
        </MessageStatus>
      </template>

      <template v-slot:item.recipients="{item: message}">
        <ul v-if="message?.recipients?.data?.length > 0"
            class="my-0 list-unstyled">
          <li v-for="recipient in recipients(message)">
            {{ recipient }}
          </li>
        </ul>
      </template>

      <template v-slot:item.delivered_at="{item: message}">
        <template v-if="message.delivered_at">
          {{ message.delivered_at | datetime('YYYY-MM-DD h:mm a') }}
        </template>
      </template>
      <template v-slot:item.opened_at="{item: message}">
        <template v-if="message.opened_at">
          {{ message.opened_at | datetime('YYYY-MM-DD h:mm a') }}
        </template>
      </template>
      <template v-slot:item.clicked_at="{item: message}">
        <template v-if="message.clicked_at">
          {{ message.clicked_at | datetime('YYYY-MM-DD h:mm a') }}
        </template>
      </template>
      <template v-slot:item.failed_at="{item: message}">
        <template v-if="message.failed_at">
          {{ message.failed_at | datetime('YYYY-MM-DD h:mm a') }}
        </template>
      </template>
      <template v-slot:item.complained_at="{item: message}">
        <template v-if="message.complained_at">
          {{ message.complained_at | datetime('YYYY-MM-DD h:mm a') }}
        </template>
      </template>
    </v-data-table>
    <v-dialog v-if="showMessageDialog"
              v-model="showMessageDialog"
              max-width="90%">
      <AdminMessageCard :busy="busy"
                        :in-dialog="true"
                        :message="message"
                        :raw="raw"
                        @closed="closeMessageDialog">
      </AdminMessageCard>
    </v-dialog>
  </div>
</template>
<script>

import AdminMessageCard from './AdminMessageCard.vue';
import mailgunService from '../../../../../../ml/services/mailgunService';
import MessageStatus from '../../../mailgun/components/MessageStatus.vue';

export default {
  components: {MessageStatus, AdminMessageCard},
  props: {
    form: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    messages: {
      type: Array,
      required: true,
    },
    serverItemsLength: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: 25,
    }
  },
  data() {
    return {
      initialized: false,
      tableHeight: '600px',
      busy: false,
      message: null,
      raw: null,
      showMessageDialog: false,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Created',
          value: 'created_at',
          cellClass: 'text-no-wrap',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          cellClass: 'text-no-wrap',
          sortable: false,
        },
        {
          text: 'Sender',
          value: 'sender',
          cellClass: 'text-no-wrap',
          sortable: false,
        },
        {
          text: 'Recipients',
          value: 'recipients',
          cellClass: 'text-no-wrap',
          sortable: false,
        },
        {
          text: 'Template',
          value: 'template.name',
          cellClass: 'text-no-wrap',
          sortable: false,
        },
        {
          text: 'Subject',
          value: 'subject',
          cellClass: 'text-no-wrap',
          sortable: false,
        },
        {
          text: 'Tag',
          value: 'tag',
          cellClass: 'text-no-wrap',
          sortable: false,
        },
        {
          text: 'Delivered',
          value: 'delivered_at',
          cellClass: 'text-no-wrap',
          sortable: false,
        },
        {
          text: 'Opened',
          value: 'opened_at',
          cellClass: 'text-no-wrap',
          sortable: false,
        },
        {
          text: 'Clicked',
          value: 'clicked_at',
          cellClass: 'text-no-wrap',
          sortable: false,
        },
        {
          text: 'Failed',
          value: 'failed_at',
          cellClass: 'text-no-wrap',
          sortable: false,
        },
        {
          text: 'Complained',
          value: 'complained_at',
          cellClass: 'text-no-wrap',
          sortable: false,
        },
      ]
    },
    fixedHeader() {
      return this.messages.length > 0;
    },
  },
  mounted() {
    //this.adjustTableHeight();
  },
  watch: {
    messages: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal && newVal.length > 0) {
        this.$nextTick(() => {
          this.adjustTableHeight();
        });
      }
    },
  },
  methods: {
    adjustTableHeight() {
      if (this.loading) {
        this.tableHeight = null;
        return;
      }
      if (this.fixedHeader === false) {
        this.tableHeight = null;
        return;
      }
      const scrollbarHeight = 22;
      const header = document.querySelector('#data-table .v-data-table-header');
      const footer = document.querySelector('#data-table .v-data-footer');
      if (header && footer) {
        const windowHeight = window.innerHeight;
        const headerTop = header.getBoundingClientRect().top;
        const footerHeight = footer.getBoundingClientRect().height + 12;
        const lastRowBottom = document.querySelector('#data-table tbody > tr:last-child')?.getBoundingClientRect().bottom;
        if (lastRowBottom) {
          if (lastRowBottom > windowHeight) {
            let height = windowHeight - headerTop - footerHeight;
            this.tableHeight = `${height}px`;
            //console.log(`set tableHeight = LAST ROW = ${this.tableHeight}`)
            return;
          }
        }
        // let maxHeight = windowHeight - headerTop - footerHeight;
        // this.tableHeight =`${maxHeight}px`;
        this.tableHeight = null;
        //console.log(`set tableHeight = maxHeight = ${this.tableHeight}`)
      } else {
        this.tableHeight = `600px`;
      }
    },
    recipients(message) {
      return message?.recipients?.data.map(recipient => recipient.recipient_email)
    },
    updateItemsPerPage(itemsPerPage) {
      this.$emit('update:items-per-page', itemsPerPage);
    },
    updatePage(page) {
      this.$emit('update:page', page);
    },
    async openMessageDialog(messageID) {
      // @see https://stackoverflow.com/questions/61396466/how-to-disable-a-vuejs-router-link
      this.busy = true;
      try {
        this.message = await mailgunService.getMessage(messageID);
        this.raw = await mailgunService.getMessageRaw(messageID);
        this.showMessageDialog = true;
      } catch (e) {
        this.showMessageDialog = false;
      } finally {
        this.busy = false;
      }
    },
    closeMessageDialog() {
      this.busy = false;
      this.showMessageDialog = false;
      this.message = null;
      this.raw = null;
    }
  }
}
</script>
